import { useLayoutEffect, useMemo } from 'react';

import {
  getAnnotationStackOrderKey,
  syncKonvaStackingOrder,
} from '../utils/reorderAnnotationsInStack';
import useStore from './useStore';

/**
 * Keeps Konva draw order in sync with annotations key order (reorder, undo, redo, load).
 */
const useSyncAnnotationStackOrder = (designLayerRef, previewGroupRef) => {
  const { annotations = {}, designLayer } = useStore();
  const stackOrderKey = useMemo(
    () => getAnnotationStackOrderKey(annotations),
    [annotations],
  );

  useLayoutEffect(() => {
    const layer = designLayerRef?.current ?? designLayer;
    if (!layer) {
      return;
    }

    syncKonvaStackingOrder(
      layer,
      annotations,
      previewGroupRef?.current ?? null,
    );
  }, [stackOrderKey, designLayer, designLayerRef, previewGroupRef, annotations]);
};

export default useSyncAnnotationStackOrder;
